import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Agente } from '@tivic-team/manager-ts/dist/mob/entities/agente.entity';
import { AgenteSearch } from 'app/services/mob/agente.search';
import { AgenteService } from 'app/services/mob/agente.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, Observable, from } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-agente-form',
  templateUrl: './autocomplete-agente-form.component.html',
  styleUrls: ['./autocomplete-agente-form.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteAgenteFormComponent implements OnInit {
  validate = false;
 
  formGroup: FormGroup;
  agentes: Agente[];
  @ViewChild("cdAgente", { static: true }) cdAgente: ElementRef;
  private _cdAgente;

  constructor(
    private _agenteService: AgenteService,
    private _controlContainer: ControlContainer
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('agente', new FormControl());

    this.formGroup.get('agente').valueChanges.pipe(
      filter(keyword => this._validarTexto(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(agentes => this._finalizarBusca(agentes))
    ).subscribe();
  }

  async ngAfterViewInit() {
    this.formGroup.get('cdAgente').valueChanges.pipe(
      mergeMap(cdAgente => this._carregar(cdAgente)),
      map(agente => this.agenteSelecionado(agente)),
    ).subscribe();
  }

  agenteSelecionado(agente: Agente) {
    if(!agente) return;

    this.cdAgente.nativeElement.value = agente.nmAgente;
    this._cdAgente = agente.cdAgente;
    this.formGroup.patchValue({ cdAgente: agente.cdAgente });
    this.formGroup.markAsDirty();
    
  }
  
  displayNmAgente(agente: Agente) {
    return (agente && agente.nmAgente) || '';
  }

  clear() {
    this.formGroup.reset();
  }

  private _carregar(cdAgente): Observable<Agente>{
    if(!cdAgente || isNaN(cdAgente) || this._cdAgente === cdAgente){
      return EMPTY;
    }

    return from(this._agenteService.get(cdAgente));
  }

  private _validarTexto(keyword: string){
    return keyword && keyword.length > 2;
  }

  private _buscar(keyword: string){
    return from(this._agenteService.find(
      new AgenteSearch({ nmAgente: keyword })
    ));
  }

  private _finalizarBusca(resultado: Agente[]){
    this.agentes = resultado
  }
}
